var React = require('react');

function ArrowPrev (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2.1005 7.41402L2.10032 7.41421L0.686104 5.99999L5.63585 1.05025C6.02638 0.659724 6.65954 0.659724 7.05007 1.05025C7.44059 1.44077 7.44059 2.07394 7.05007 2.46446L3.51472 5.99981L7.05044 9.53553C7.44096 9.92606 7.44096 10.5592 7.05044 10.9497C6.65991 11.3403 6.02675 11.3403 5.63622 10.9497L2.1005 7.41402Z","fill":"#003B1B"}));
}

ArrowPrev.defaultProps = {"width":"8","height":"12","viewBox":"0 0 8 12","fill":"none"};

module.exports = ArrowPrev;

ArrowPrev.default = ArrowPrev;
